import type { BelegTyp } from "../types";
import { Screen, ScreenHeader, Display, Lede } from "../ui/components";
import { Ico } from "../ui/Ico";
import { C } from "../ui/tokens";

interface Option {
  belegTyp: BelegTyp;
  title: string;
  description: string;
}

const OPTIONS: Option[] = [
  {
    belegTyp: "Spesen",
    title: "Spesen",
    description:
      "Sachen, die ich zum Arbeiten brauche, zum Beispiel ein Zugticket oder ein Lunch mit einem Kunden.",
  },
  {
    belegTyp: "Rückvergütung",
    title: "Rückvergütung",
    description:
      "Ich habe etwas für die Firma ausgelegt (z. B. Früchte im Coop) und Bitforge zahlt mir den Betrag zurück.",
  },
  {
    belegTyp: "Kreditkartenbelege",
    title: "Kreditkartenbeleg",
    description:
      "Ich habe mit der Bitforge-Kreditkarte bezahlt. Das ist der Beleg.",
  },
];

interface Props {
  onSelect: (belegTyp: BelegTyp) => void;
  onBack: () => void;
}

export function BelegTypSelect({ onSelect, onBack }: Props) {
  return (
    <Screen>
      <ScreenHeader back={onBack} />
      <Display>Was trifft zu?</Display>
      <Lede>Wähle aus, um was für einen Beleg es sich handelt.</Lede>

      <div style={{ marginTop: 32, display: "flex", flexDirection: "column", gap: 12 }}>
        {OPTIONS.map((o) => (
          <OptionCard key={o.belegTyp} option={o} onSelect={() => onSelect(o.belegTyp)} />
        ))}
      </div>
    </Screen>
  );
}

function OptionCard({ option, onSelect }: { option: Option; onSelect: () => void }) {
  return (
    <button
      onClick={onSelect}
      style={{
        width: "100%", padding: "20px 22px",
        background: C.surface, border: `1px solid ${C.border}`,
        borderRadius: 20, cursor: "pointer",
        display: "flex", alignItems: "center", gap: 16,
        textAlign: "left", color: C.fg,
        transition: "border-color 150ms ease, background 150ms ease, transform 120ms ease",
      }}
      onMouseDown={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = "scale(0.985)"; }}
      onMouseUp={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = "scale(1)"; }}
      onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = "scale(1)"; }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 19, fontWeight: 600, letterSpacing: "-0.015em",
          color: C.fg, marginBottom: 6,
        }}>
          {option.title}
        </div>
        <div style={{ fontSize: 13, lineHeight: 1.45, color: C.fg2 }}>
          {option.description}
        </div>
      </div>
      <div style={{
        width: 36, height: 36, borderRadius: 12,
        background: C.surface2, border: `1px solid ${C.border}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0,
      }}>
        <Ico name="chev" size={18} color={C.fg2} />
      </div>
    </button>
  );
}
